import { render } from "./FileUploader.vue?vue&type=template&id=2b85a6b9"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"
script.render = render

export default script